var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "content devices",
    },
    [
      _vm.locations.length === 0
        ? _c("el-card", [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [
                _c("span", { staticClass: "header-item" }, [
                  _vm._v("Locations"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-content" }, [
              _vm._v("\n      This customer has no locations\n    "),
            ]),
          ])
        : _c(
            "div",
            [
              _vm._l(_vm.locations, function (location) {
                return _c("LocationDetails", {
                  key: location.id,
                  attrs: {
                    "data-id": location.location_id,
                    customer: _vm.customer,
                    location: location,
                    owner: _vm.locationOwner(location.owner_id),
                    users: _vm.locationUsers(location.location_id),
                    "smb-users": location.authorized_users,
                    devices: _vm.sortedLocationDevices(location.location_id),
                    sos: _vm.locationSos(location.location_id),
                  },
                })
              }),
              _vm._v(" "),
              _c("el-pagination", {
                staticStyle: { padding: "25px 0 20px" },
                attrs: {
                  background: "",
                  "hide-on-single-page": true,
                  "current-page": _vm.pagination.currentPage,
                  "page-size": _vm.pagination.size,
                  layout: "prev, pager, next",
                  total: _vm.pagination.total,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.pagination, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.pagination, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }